module.exports = __webpack_public_path__ + "media/images/USA-banner3-8b774ec2fc7ebda20b3e1df0668c9b02.jpg";